var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEuroCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38142 14.5C5.95285 14.5 4.0957 13.0495 4.0957 11.3352V10.544H3.38128C2.95271 10.544 2.66699 10.2802 2.66699 9.88462C2.66699 9.48901 2.95271 9.22528 3.38128 9.22528H4.0957V7.90659H3.38128C2.95271 7.90659 2.66699 7.64286 2.66699 7.24725C2.66699 6.85165 2.95271 6.58791 3.38128 6.58791H4.0957V5.66484C4.0957 3.95055 5.95285 2.5 8.38142 2.5C10.81 2.5 12.5243 3.55494 12.6671 5.13736C12.6671 5.53297 12.3814 5.7967 11.9528 5.7967C11.5243 5.7967 11.2386 5.53297 11.2386 5.13736C11.0957 4.21429 9.80999 3.81868 8.38142 3.81868C6.80999 3.81868 5.52427 4.60989 5.52427 5.66484V6.58791H7.66699C8.09556 6.58791 8.38128 6.85165 8.38128 7.24725C8.38128 7.64286 8.09556 7.90659 7.66699 7.90659H5.52427V9.22528H7.66699C8.09556 9.22528 8.38128 9.48901 8.38128 9.88462C8.38128 10.2802 8.09556 10.544 7.66699 10.544H5.52427V11.3352C5.52427 12.2582 6.80999 13.1813 8.38142 13.1813C10.3814 13.1813 11.2386 13.0495 11.2386 12.522C11.2386 12.1264 11.6671 11.8626 11.9528 11.8626C12.3814 11.8626 12.6671 12.2582 12.6671 12.522C12.5243 14.5 10.2386 14.5 8.38142 14.5Z",
    fill: "#FFE14D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEuroCoin);
export default __webpack_public_path__ + "static/media/iconEuroCoin.bff021fca0d88879851fb8f4900a38e7.svg";
export { ForwardRef as ReactComponent };